import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=5ce588c5&scoped=true"
import script from "./viewImage.vue?vue&type=script&lang=js"
export * from "./viewImage.vue?vue&type=script&lang=js"
import style0 from "./viewImage.vue?vue&type=style&index=0&id=5ce588c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce588c5",
  null
  
)

export default component.exports